import { render, staticRenderFns } from "./testClassInfo.vue?vue&type=template&id=8f463354&scoped=true&"
import script from "./testClassInfo.vue?vue&type=script&lang=ts&"
export * from "./testClassInfo.vue?vue&type=script&lang=ts&"
import style0 from "./testClassInfo.vue?vue&type=style&index=0&id=8f463354&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f463354",
  null
  
)

export default component.exports